export { default as LinkifyIt } from 'linkify-it';
